<template>
  <div
    class="flex flex-nowrap gap-px md:gap-2"
  >
    <QBtn
      label="로그인"
      color="secondary"
      unelevated
      icon="person"
      rounded
      @click="authStore.showLoginModal = true"
    />
    <QBtn
      :to="{name:'registration'}"
      label="회원가입"
      color="secondary"
      outline
      icon="app_registration"
      rounded
      unelevated
    />
    <!--    <QBtn-->
    <!--      label="비회원문의"-->
    <!--      rounded-->
    <!--      color="accent"-->
    <!--      icon="question_answer"-->
    <!--      unelevated-->
    <!--      @click="authStore.showGuestQuestionModal = true"-->
    <!--    />-->
  </div>
</template>
<script setup>
import {useAuthStore} from "@/stores/auth";

const authStore = useAuthStore()
</script>
